module.exports = __webpack_public_path__ + "static/img/33.8dc5a5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/33.png
// module id = Uvj7
// module chunks = 1